import { programDetail } from '@/network/apis/apiUri';
import { memo } from 'react';
import { useQuery } from 'react-query';
import { Link, useLocation } from 'react-router-dom';

export default memo(function HeaderBreadCrumb(props) {
  const { page } = props;

  const location = useLocation();
  const [, , programId] = location.pathname.split('/');

  const { isSuccess, data } = useQuery(
    ['nav', page, 'deps', programId],
    async () => {
      if (!programId) {
        return { text: null, link: '' };
      }
      if (programId === 'podcast' || programId === 'vod') {
        return { text: programId, link: `/${page}/${programId}/main` };
      }
      const response = await programDetail({
        program_id: programId,
        lan_code: 'en',
      });

      return { text: response.data.title[0].text, link: `/${page}/${programId}` };
    },
    { retry: false }
  );

  return (
    <div className="header__breadcrumb-wrapper">
      <nav className="header__breadcrumb">
        <ul>
          <li>
            <Link to="/">HOME</Link>
          </li>
          {page && (
            <li>
              <Link to={`/${page}`}>{page.toUpperCase()}</Link>
            </li>
          )}
          {isSuccess && data.text && (
            <li>
              <Link to={data.link}>{data.text}</Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
});
